import { Pressable, View } from 'react-native'
import { styled } from '~/utils/styled'

export const Root = styled(Pressable, theme => {
  return {
    base: {
      flexDirection: 'column',
      borderRadius: theme.borderRadiusPill,
      backgroundColor: 'transparent',
      minWidth: theme.sizingHuge,
      minHeight: theme.sizingSmall,
      width: 'auto',
    },
    variants: {
      size: {
        md: {
          minWidth: theme.sizingMedium,
        },
        ml: {
          minWidth: theme.sizingMediumlarge,
        },
      },
      hasFull: {
        true: {
          width: '100%',
        },
      },
      hasFocused: {
        true: {
          backgroundColor: 'transparent',
          borderColor: theme.colorActionBorderFocused,
          borderWidth: theme.borderWidthHalfpulse,
        },
      },
      hasDisabled: {
        true: {
          borderColor: 'transparent',
          backgroundColor: 'transparent',
          borderWidth: theme.borderWidthNone,
        },
      },
    },
  }
})

export const RootView = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacingInlineOnepulse,
      backgroundColor: 'transparent',
      width: '100%',
    },
    variants: {
      size: {
        md: {
          height: theme.sizingMedium,
          paddingHorizontal: theme.paddingInsetFourpulse,
        },
        ml: {
          height: theme.sizingMediumlarge,
          paddingHorizontal: theme.paddingInsetFourpulse,
        },
      },
      hasPressed: {
        true: {
          backgroundColor: theme.colorActionFillNeutralTertiaryPressed,
          borderColor: theme.colorActionBorderNeutralTertiaryPressed,
          borderWidth: theme.borderWidthHalfpulse,
        },
      },
      hasDisabled: {
        true: {
          borderColor: 'transparent',
          backgroundColor: 'transparent',
          borderWidth: theme.borderWidthNone,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          size: 'ml',
        },
        css: {
          paddingLeft: theme.paddingInsetFourpulse,
          paddingRight: theme.paddingInsetFourpulse,
          paddingTop: theme.paddingInsetTwopulse,
          paddingBottom: theme.paddingInsetTwopulse,
        },
      },
      {
        variants: {
          size: 'md',
        },
        css: {
          paddingLeft: theme.paddingInsetFourpulse,
          paddingRight: theme.paddingInsetFourpulse,
          paddingTop: theme.paddingInsetTwopulse,
          paddingBottom: theme.paddingInsetTwopulse,
        },
      },
    ],
  }
})
